export const newBWICSteps = {
    securities: 'Securities & Time',
    process: 'Process',
    participants: 'Participants',
    documents: 'Documents',
    submit: 'Submit'
};